import React from "react";
import "./BcValueCircle.css";

// Shared presentational green circle for Business-Central dollar-value widgets
// (Inventory Over 90, A/R Over 90, ...). Pass a title and the numeric value;
// null value renders a loading ellipsis.
//
// Pass `onClick` to make the circle a button that opens a detail modal — it then
// renders as a real <button> (keyboard focusable) with a hover cue and a small
// "View details" hint beneath the value.
const BcValueCircle = ({ title, value, onClick }) => {
  const formatted =
    value == null
      ? "…"
      : Number(value).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 0,
        });

  const inner = (
    <>
      <span className="bcvc-label">{title}</span>
      <span className="bcvc-value">{formatted}</span>
      {onClick && <span className="bcvc-hint">View details</span>}
    </>
  );

  return (
    <div className="bcvc-widget">
      {onClick ? (
        <button
          type="button"
          className="bcvc-circle bcvc-clickable"
          onClick={onClick}
          title={`View ${title} details`}
        >
          {inner}
        </button>
      ) : (
        <div className="bcvc-circle">{inner}</div>
      )}
    </div>
  );
};

export default BcValueCircle;
